import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoDrinksIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_drinks"}/>
}
